import React from "react";
import styles from "./index.module.scss";
import DesignToCart from "@components/CustomComponents/DesignToCart";

const ProductDetails = props => {
  const { productDetailsData } = props;
  if (productDetailsData?.componentType === "Design To Cart") {
  return <DesignToCart data={productDetailsData} />;
  }
  const items =
    productDetailsData?.productDetailsItems?.map(item => ({
      id: item?.sys?.id,
      title: item?.fields?.title,
      itemNo: item?.fields?.itemNumber,
      description:
        item?.fields?.description?.content?.[0]?.content?.[0]?.value || "",
      imageUrl: item?.fields?.imageUrl,
      link: item?.fields?.link,
    })) || [];

  return (
    <section className={styles.container}>
      <h2 className={styles.header}>{props?.productDetailsData?.title}</h2>

      <div className={styles.grid}>
        {items.map(item => (
          <div key={item.id} className={styles.card}>
            <img src={item.imageUrl} alt={item.title} />

            <div className={styles.cardInfo}>
              <div className={styles.title}>{item.title}</div>
              <div className={styles.itemNo}>{item.itemNo}</div>
              <div className={styles.desc}>{item.description}</div>

              <a href={item.link} className={styles.more}>
                more
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductDetails;
